export default __webpack_public_path__ + "static/media/FSEmericWeb-Light.eef50fd2.woff2";